





































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { State, Action, namespace } from 'vuex-class'
import { YKDModal } from 'gum-ui'
import TaskItem from './components/item.vue'
import { PageDayPlan } from '@/model/plan/dayPlan'
import moment from 'moment'

import VueScrollTo from 'vue-scrollto'

let options = {
  container: '.modal-allplan-body', //滚动的容器
  duration: 500, //滚动时间
  easing: 'ease-in-out', //缓动类型
  offset: 0, //滚动时应应用的偏移量。此选项接受回调函数
  force: true, //是否应执行滚动
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
}

Vue.use(VueScrollTo, options)

const ModuleStudyPlan = namespace('app-ice/studyPlan')

@Component({
  components: {
    YKDModal,
    TaskItem,
  },
})
export default class StudyPlanAllModal extends Vue {
  @ModuleStudyPlan.State((state) => state.allPlan)
  private allPlan!: Array<PageDayPlan>
  @ModuleStudyPlan.State((state) => state.allStudyPlanModal)
  private allStudyPlanModal!: boolean
  @ModuleStudyPlan.Action('controlAllStudyPlanModal')
  controlAllStudyPlanModal!: Function

  audio: any = ''

  // unlock 判断
  // TODO 定位后特效

  closeAllStudyPlanModal() {
    this.controlAllStudyPlanModal(false)
    this.audio && this.audio.pause()
  }

  updateAudio(audio: any) {
    this.audio = audio
  }

  @Watch('allStudyPlanModal')
  onVisibleChange() {
    if (this.allStudyPlanModal) {
      this.$nextTick(() => {
        // this.scroll2El('.current-plan')
        this.scroll2El('.lastest-plan')
      })
    }
  }

  scroll2El(selector: string) {
    const el = document.querySelector(selector)
    const body = document.querySelector('.modal-allplan-body')
    if (el && body) {
      // TODO check scroll offset
      options.offset = -(body.clientHeight - el.clientHeight) / 2
      //@ts-ignore
      options.onDone = this.onDone
      //@ts-ignore
      VueScrollTo.scrollTo(el, options)
    }
  }

  get filteredAllPlan() {
    return this.allPlan.filter(
      (p: PageDayPlan) => !!p.dayPlanOutlines && p.actived
    )
  }

  // 定位后特效
  onDone() {}

  // isSame(dateStr: string) {
  //   return moment(dateStr).isSame(moment(), 'day')
  // }
}
